import providerModuleActions from "./providerModule/actions";

export default {
  ...providerModuleActions,
};
